import { useIsMobile } from "hooks/useIsMobile";
import React, { FC } from "react";
import CommonLayout from "./CommonLayout";
import CommonLayoutMobile from "./CommonLayoutMobile";

export interface AccountLayoutWrapperProps {
  children?: React.ReactNode;
}

export const AccountLayoutWrapper: FC<AccountLayoutWrapperProps> = ({
  children,
}) => {
  const { isMobile } = useIsMobile();
  console.log('isMobile',isMobile)
  return !isMobile ? (
    <CommonLayout>{children}</CommonLayout>
  ) : (
    <CommonLayoutMobile>{children}</CommonLayoutMobile>
  );
};
